var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M14.274 9.726a5.475 5.475 0 01.381 7.31c-.244.303-.109.152-3.318 3.36a5.464 5.464 0 01-7.734 0 5.464 5.464 0 010-7.733l2.477-2.479c.292-.291.794-.092.8.32.008.498.07.994.186 1.478a.466.466 0 01-.125.437L5.15 14.21a3.28 3.28 0 000 4.641 3.279 3.279 0 004.64 0l2.937-2.937a3.285 3.285 0 00-.89-5.274.471.471 0 01-.257-.483 2.02 2.02 0 01.579-1.187l.17-.171a.466.466 0 01.538-.09c.508.255.984.594 1.407 1.018zm6.123-6.123a5.466 5.466 0 00-7.734 0c-3.21 3.21-3.074 3.058-3.318 3.36a5.477 5.477 0 00.38 7.311c.424.424.9.763 1.408 1.018.179.09.396.052.537-.09l.171-.17c.333-.334.526-.754.579-1.188a.472.472 0 00-.256-.483 3.285 3.285 0 01-.891-5.274L14.21 5.15a3.279 3.279 0 014.64 0 3.279 3.279 0 010 4.64l-1.79 1.79a.468.468 0 00-.126.438c.116.485.178.98.186 1.478.006.412.508.611.8.32l2.477-2.479a5.465 5.465 0 000-7.734z"
  }))));
}

export default SvgLink;